import gridRebirth from "./grid-rebirth";

const grid = {
  ...gridRebirth,
  wrapperOuterMargin: {
    ...gridRebirth.wrapperOuterMargin,
    large: 56,
    medium: 33,
    small: 28,
  },
  gridCols: {
    ...gridRebirth.gridCols,
    medium: 8,
  },
};

export default grid;
